import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createSlots as _createSlots, vModelText as _vModelText, withDirectives as _withDirectives, Teleport as _Teleport, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0ad006b2")

_pushScopeId("data-v-0ad006b2")
const _hoisted_1 = {
  class: "card promotion-table",
  ref: "listRoot"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "text-nowrap" }
const _hoisted_5 = {
  key: 0,
  class: "recipient-preview"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "text-nowrap" }
const _hoisted_9 = { class: "text-nowrap" }
const _hoisted_10 = {
  key: 0,
  class: "badge badge-light-primary"
}
const _hoisted_11 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "fas fa-ellipsis-h" }, null, -1)
const _hoisted_13 = {
  ref: "recipientsModalEl",
  class: "modal fade recipients-modal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_14 = { class: "modal-dialog modal-dialog-centered mw-900px recipients-dialog" }
const _hoisted_15 = { class: "modal-content" }
const _hoisted_16 = { class: "modal-header" }
const _hoisted_17 = { class: "mb-0" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", {
  class: "btn btn-sm btn-icon",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-1" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_19 = { class: "modal-body" }
const _hoisted_20 = { class: "d-flex align-items-center justify-content-between mb-4" }
const _hoisted_21 = { class: "fw-bold text-gray-700" }
const _hoisted_22 = {
  key: 0,
  class: "recipient-list"
}
const _hoisted_23 = { class: "table table-row-bordered align-middle gy-3 mb-0" }
const _hoisted_24 = { class: "fw-bold text-gray-700" }
const _hoisted_25 = { class: "menu-item-wrapper" }
const _hoisted_26 = { class: "menu-item" }
const _hoisted_27 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-edit" })
], -1)
const _hoisted_28 = { class: "menu-item" }
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-trash" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TableContentLoader = _resolveComponent("TableContentLoader")!
  const _component_Table = _resolveComponent("Table")!
  const _component_InnerLoader = _resolveComponent("InnerLoader")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      (_ctx.loader)
        ? (_openBlock(), _createBlock(_component_TableContentLoader, { key: 0 }))
        : (_openBlock(), _createBlock(_component_Table, {
            key: 1,
            columns: _ctx.columns,
            rows: _ctx.promotions,
            padding: 3,
            loading: _ctx.loader
          }, _createSlots({
            "cell-title": _withId(({ row: item }) => [
              _createVNode("span", {
                class: "promotion-text",
                title: item.title
              }, _toDisplayString(item.title || '-'), 9, ["title"])
            ]),
            "cell-message": _withId(({ row: item }) => [
              _createVNode("span", {
                class: "promotion-text",
                title: item.message
              }, _toDisplayString(item.message || '-'), 9, ["title"])
            ]),
            "cell-image": _withId(({ row: item }) => [
              (item.image?.file_path || item.image_path)
                ? (_openBlock(), _createBlock("img", {
                    key: 0,
                    src: item.image?.file_path || item.image_path,
                    alt: "",
                    class: "promotion-thumb"
                  }, null, 8, ["src"]))
                : (_openBlock(), _createBlock("span", _hoisted_2, "-"))
            ]),
            "cell-url": _withId(({ row: item }) => [
              (item.url)
                ? (_openBlock(), _createBlock("a", {
                    key: 0,
                    href: item.url,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    class: "promotion-url"
                  }, _toDisplayString(item.url), 9, ["href"]))
                : (_openBlock(), _createBlock("span", _hoisted_3, "-"))
            ]),
            "cell-audience_type": _withId(({ row: item }) => [
              _createVNode("span", _hoisted_4, _toDisplayString(_ctx.audienceLabel(item.audience_type)), 1)
            ]),
            "cell-audience_summary": _withId(({ row: item }) => [
              (item.recipient_count)
                ? (_openBlock(), _createBlock("div", _hoisted_5, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.recipient_preview, (name, index) => {
                      return (_openBlock(), _createBlock("span", {
                        key: index,
                        class: "recipient-name",
                        title: name
                      }, [
                        _createTextVNode(_toDisplayString(name), 1),
                        (index < item.recipient_preview.length - 1)
                          ? (_openBlock(), _createBlock("span", _hoisted_6, ","))
                          : _createCommentVNode("", true)
                      ], 8, ["title"]))
                    }), 128)),
                    (_ctx.extraCount(item) > 0)
                      ? (_openBlock(), _createBlock("button", {
                          key: 0,
                          type: "button",
                          class: "recipient-more",
                          onClick: ($event: any) => (_ctx.openRecipients(item))
                        }, " +" + _toDisplayString(_ctx.extraCount(item)), 9, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createBlock("span", _hoisted_7, "-"))
            ]),
            "cell-status": _withId(({ row: item }) => [
              (item?.status == 1 || item?.status === true)
                ? (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(_ctx.$t('message.ACTIVE')), 1))
                : (_openBlock(), _createBlock("span", _hoisted_11, _toDisplayString(_ctx.$t('message.INACTIVE')), 1))
            ]),
            "cell-actions": _withId(({ row: item }) => [
              _createVNode("button", {
                class: "action-btn",
                type: "button",
                onClick: _withModifiers(($event: any) => (_ctx.dropdownHandler($event, item)), ["stop"])
              }, [
                _hoisted_12
              ], 8, ["onClick"])
            ]),
            _: 2
          }, [
            (_ctx.promotionType !== 'SERVICE')
              ? {
                  name: "cell-starts_at",
                  fn: _withId(({ row: item }) => [
                    _createVNode("span", _hoisted_8, _toDisplayString(_ctx.formatDate(item.starts_at)), 1)
                  ])
                }
              : undefined,
            (_ctx.promotionType !== 'SERVICE')
              ? {
                  name: "cell-ends_at",
                  fn: _withId(({ row: item }) => [
                    _createVNode("span", _hoisted_9, _toDisplayString(_ctx.formatDate(item.ends_at)), 1)
                  ])
                }
              : undefined
          ]), 1032, ["columns", "rows", "loading"]))
    ], 512),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode("div", _hoisted_13, [
        _createVNode("div", _hoisted_14, [
          _createVNode("div", _hoisted_15, [
            _createVNode("div", _hoisted_16, [
              _createVNode("h2", _hoisted_17, _toDisplayString(_ctx.$t('message.RECIPIENTS')), 1),
              _hoisted_18
            ]),
            _createVNode("div", _hoisted_19, [
              _createVNode("div", _hoisted_20, [
                _createVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('message.RECIPIENTS')) + " (" + _toDisplayString(_ctx.recipientSearch.trim() ? _ctx.filteredRecipients.length : _ctx.selectedPromotion?.recipient_count || 0) + ")", 1)
              ]),
              _withDirectives(_createVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.recipientSearch = $event)),
                type: "text",
                class: "form-control mb-4",
                placeholder: _ctx.$t('message.SEARCH')
              }, null, 8, ["placeholder"]), [
                [_vModelText, _ctx.recipientSearch]
              ]),
              _createVNode(_component_InnerLoader, {
                loading: _ctx.recipientsLoading,
                innerLoading: true
              }, null, 8, ["loading"]),
              (!_ctx.recipientsLoading)
                ? (_openBlock(), _createBlock("div", _hoisted_22, [
                    _createVNode("table", _hoisted_23, [
                      _createVNode("thead", null, [
                        _createVNode("tr", _hoisted_24, [
                          _createVNode("th", null, _toDisplayString(_ctx.$t('message.NAME')), 1),
                          _createVNode("th", null, _toDisplayString(_ctx.$t('message.EMAIL')), 1),
                          _createVNode("th", null, _toDisplayString(_ctx.$t('message.PHONE_NUMBER')), 1),
                          _createVNode("th", null, _toDisplayString(_ctx.$t('message.ACCOUNT_ECONOMIC_NUMBER')), 1),
                          _createVNode("th", null, _toDisplayString(_ctx.$t('message.CUSTOMER_GROUP')), 1)
                        ])
                      ]),
                      _createVNode("tbody", null, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredRecipients, (customer) => {
                          return (_openBlock(), _createBlock("tr", {
                            key: customer.id
                          }, [
                            _createVNode("td", null, _toDisplayString(customer.name || '-'), 1),
                            _createVNode("td", null, _toDisplayString(customer.email || '-'), 1),
                            _createVNode("td", null, _toDisplayString(customer.phone_number || '-'), 1),
                            _createVNode("td", null, _toDisplayString(customer.economic_number || '-'), 1),
                            _createVNode("td", null, _toDisplayString(customer.customer_group || '-'), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ], 512)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.actionMenu.open)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            ref: "actionMenuEl",
            class: ["dropdown-menu action-dropdown promotion-row-menu", { 'promotion-row-menu-dark': _ctx.asideTheme === 'dark' }],
            style: { top: _ctx.actionMenu.top + 'px', left: _ctx.actionMenu.left + 'px' },
            onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createVNode("div", _hoisted_25, [
              _createVNode("div", _hoisted_26, [
                _createVNode("a", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editPromotion(_ctx.actionMenu.item))),
                  class: "menu-link me-1"
                }, [
                  _hoisted_27,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('message.EDIT')), 1)
                ])
              ]),
              _createVNode("div", _hoisted_28, [
                _createVNode("a", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deletePromotion(_ctx.actionMenu.item.id))),
                  class: "menu-link me-1"
                }, [
                  _hoisted_29,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('message.DELETE')), 1)
                ])
              ])
            ])
          ], 6))
        : _createCommentVNode("", true)
    ]))
  ], 64))
})